<template>
    <div v-show="false" class="helper"></div>
</template>

<script>
    export default {
        name: "ProfileDamMxGraph",
        data() {
            return {
                script: null
            }
        },
        mounted() {
            this.$loadScript('/viewer.min.js')
                .then((viewer) => {
                    // set id to new script as to get it later
                    viewer.id = 'imported-viewer';
                    viewer.type = 'application/javascript';
                    this.script = viewer;
                    document.body.appendChild(viewer);
                })
                .catch((error) => {
                    console.log('error: ', error);
                })
        },
        beforeDestroy() {
            // try remove the old script
            try {
                const oldViewerNode = document.getElementById('imported-viewer');
                oldViewerNode.remove();
            } catch (removeError) {
                console.error("Couldn't remove old script due to: ", removeError);
            }
        }
    }
</script>
